import * as places from '@wix/auto_sdk_atlas_places';
import * as autocomplete from '@wix/auto_sdk_atlas_autocomplete';
import * as location from '@wix/auto_sdk_atlas_location';

export { places, autocomplete, location };
